import { useState, useEffect } from 'react';
import useObservable from '../../hooks/useObservable';
import GtcStore from '../../xstores/gtc';
import {Box} from '../../styled';
import {floor, meanBy} from 'lodash';
import styled from 'styled-components';

const StrongSpan = styled.span`
  font-weight: 700;
`

const normalizeData = (results: any) => {
  const norm:Array<any> = [];

  results.forEach((res:any) => {
    res.platforms.forEach((pl:any) => {
      norm.push({
        query: res.query,
        pl: pl.name,
        page: pl.result.page,
        rank: pl.result.rank,
      })
    });
  });

  return norm;
}

const getGroupedData = (results:any) => {
  const normalized = normalizeData(results);
  if (!normalized.length) {
    return {};
  }
  const firstPageRes = floor(normalized.filter((n:any) => n.page === 1 && n.rank).length * 100 / normalized.length, 2);
  const averagePos = floor(meanBy(normalized, (o:any) => {
    if (!o.rank) {
      return o.page * 5;
    }
    return o.rank
  }), 2);
  return {
    firstPageRes,
    averagePos,
    notFound: normalized.filter((o:any) => !o.rank).length,
  }
}

const Stats = () => {
  const results = useObservable(GtcStore.results$, []);
  const [stats, setStats] = useState<any>({});

  useEffect(() => {
    const groupedData = getGroupedData(results);
    setStats(groupedData);
  }, [results]);

  if (!results.length) {
    return null;
  }

  return (
    <Box>
      <div>
        Average position: <StrongSpan>{stats.averagePos} </StrongSpan>
        <span style={{ fontSize: 10 }}>
          Position for not found queries are calculated with <StrongSpan>queried pages * 5</StrongSpan>
        </span>
      </div>
      <div>
        First page position: <StrongSpan>{stats.firstPageRes} %</StrongSpan>
      </div>
      <div>
        Not found queries: <StrongSpan>{stats.notFound}</StrongSpan>
      </div>
    </Box>
  )
}

export default Stats;